hostnamePartPattern